import { DialogActions, DialogContent, FormControl, Grid, TextField } from "@mui/material";
import DialogHESP from "../DialogHESP/DialogHESP";
import { SdiInput } from "./TLADatacenterDeviceContextSdiInputs";
import DialogFooterWithLoading from "../Loading/DialogFooterWithLoading";
import HESPFormLabel from "../HESPFormLabel/HESPFormLabel";
import { useEffect, useState } from "react";

interface Props {
    open: boolean;
    onClose: () => void;
    isCreate: boolean;
    sdiInput: Omit<SdiInput, "id">;
    onConfirm: (input: Omit<SdiInput, "id">) => void;
}

export default function ManageDeviceContextSdiInputDialog({ onClose, isCreate, onConfirm, open, sdiInput }: Props) {
    const [name, setName] = useState<string>(sdiInput.name);
    const [persistentId, setPersistentId] = useState<string>(sdiInput.persistentId);
    const [deviceNumber, setDeviceNumber] = useState<number>(sdiInput.deviceNumber);

    const disabled = name.trim().length === 0 || persistentId.trim().length === 0;

    useEffect(() => {
        setName(sdiInput.name);
        setPersistentId(sdiInput.persistentId);
        setDeviceNumber(sdiInput.deviceNumber);
    }, [sdiInput]);

    return (
        <DialogHESP
            title={isCreate ? "Create SDI input" : "Update SDI input"}
            open={open}
            onClose={onClose}
            content={
                <>
                    <DialogContent>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <HESPFormLabel label="Name" />
                                    <TextField type="text" value={name} onChange={(e) => setName(e.target.value)} />
                                </FormControl>
                            </Grid>

                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <HESPFormLabel label="Persistent ID" />
                                    <TextField
                                        type="text"
                                        value={persistentId}
                                        onChange={(e) => setPersistentId(e.target.value)}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <HESPFormLabel label="Device Number" />
                                    <TextField
                                        fullWidth
                                        type="number"
                                        size="small"
                                        onChange={(e) => setDeviceNumber(parseInt(e.target.value))}
                                        variant="outlined"
                                        value={deviceNumber}
                                        InputProps={{ inputProps: { min: 0, max: 1_000_000, step: 1 } }}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <DialogFooterWithLoading
                            isLoading={false}
                            disabled={disabled}
                            loadingText={isCreate ? "Create" : "Update"}
                            onCancelClick={onClose}
                            defaultText={isCreate ? "Create" : "Update"}
                            onActionClick={() =>
                                onConfirm({ name, deviceNumber, persistentId, __typename: "DeviceContextSdiInput" })
                            }
                        />
                    </DialogActions>
                </>
            }
        />
    );
}
